/**
 * El texto corto bajo el título de la portada sale de «Acerca del seminario».
 * Cortarlo en un número fijo de caracteres lo dejaba a mitad de palabra
 * («histórico-gra…»). Se usa la PRIMERA ORACIÓN si cabe; si no, se corta en el
 * último espacio antes del límite.
 */
export function leadSentence(text: string, max = 160): string {
  const clean = text.trim().replace(/\s+/g, ' ');
  if (!clean) return '';
  const first = /^.+?[.!?](?=\s|$)/.exec(clean)?.[0];
  if (first && first.length <= max) return first;
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max);
  const space = cut.lastIndexOf(' ');
  return `${(space > max * 0.5 ? cut.slice(0, space) : cut).replace(/[\s,;:–—-]+$/, '')}…`;
}
